import React, { useEffect, useMemo, useState } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import ColoredTip from '../../../../components/tips/colored-tip'
import CountDown from '../../../../../../components/count-down'
import { Iconfont } from '../../../../../../components/icon/iconfont'
import Cache from '../../../../../../../utils/cache'
import { FormattedMessage } from 'react-intl'

const CountDownPart = props => {
    useStyles(classes)
    const {offset, callback} = props

    return <div className={classes.CountDownBox}>
        <CountDown
            showHour
            offset={offset}
            numberClass={classes.numberClass}
            callback={callback}
            />
        {/*<span className={classes.CountDownText}><FormattedMessage id="ends_today" defaultMessage={"ends today"}/></span>*/}
    </div>
}

export const FreeShippingMinTip = props => {
    useStyles(classes)
    const {checkoutButtonTip} = props

    return <span className={classes.FreeShippingMinTip}>{checkoutButtonTip}</span>
}

export const FreeShippingLineTip = props => {
    useStyles(classes)
    const {underMsg} = props
    const [offsetValue, setOffsetValue] = useState()

    useEffect(() => {
        let timeNow = new Date().getTime()
        let cacheTime = Cache.get("free_shipping_offset")
        let offset = cacheTime - timeNow
        if(offset > 0){
            setOffsetValue(offset)
        } else {
            Cache.set("free_shipping_offset",  timeNow + 60*60*24*1000)
            setOffsetValue(60*60*24*1000)
        }
    }, [])

    return <div className={classes.FreeShippingLineTip}>
        <div className={classes.Icon}>
            <Iconfont>&#xe6a9;</Iconfont>
        </div>
        <div className={classes.Title}>
            {/*{underMsg}*/}
            <span dangerouslySetInnerHTML={{ __html: underMsg }} />
        </div>
        {/*{offsetValue && <CountDownPart offset={offsetValue}/>}*/}
    </div>
}


const FreeShipingTip = props => {
    useStyles(classes)
    const {cart, clickFunc, isBW,msg} = props
    const [offsetValue, setOffsetValue] = useState()

    useEffect(() => {
        let timeNow = new Date().getTime()
        let cacheTime = Cache.get("free_shipping_offset")
        let offset = cacheTime - timeNow
        if(offset > 0){
            setOffsetValue(offset)
        } else {
            Cache.set("free_shipping_offset",  timeNow + 60*60*24*1000)
            setOffsetValue(60*60*24*1000)
        }
    }, [])

    return <ColoredTip
        sensors={{
            resourcepage_title: 'cart',
            resource_position: 1,
            resource_type: '23',
            resource_content: 'shipping_addmore'
        }}
        backgroundColor="#F6FCFC"
        onClick={clickFunc}
        icon={
            <Iconfont style={{color:"#2A845E"}}>&#xe6a9;</Iconfont>
        }>
        <div><span dangerouslySetInnerHTML={{ __html: msg }} /></div>
        {/*{offsetValue && !isBW && <CountDownPart offset={offsetValue}/>}*/}
    </ColoredTip>
}

export default FreeShipingTip